import gql from 'graphql-tag';

export const HIRER_ACCOUNTS = gql`
  fragment HirerAccount on HirerAccount {
    id
    billingAccountId
    billingAddress {
      addressLine1
      country
    }
    postalAddress {
      addressLine1
      country
    }
    activationStatus
    businessName
    isArchived
    integrations {
      partner {
        id
        name
      }
      relationships {
        id
        relationshipType {
          name
          typeCode
        }
      }
    }
  }

  query HirerAccounts {
    hirerAccounts {
      totalCount
      edges {
        node {
          ...HirerAccount
        }
      }
    }
  }
`;
